import "./styles/App.css";
import Root from "./root";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "./providers/Providers";
import MetaPixel from "./components/MetaPixel";

function App() {
	return (
		<>
			<BrowserRouter>
				<Provider>
					<>
					<MetaPixel/>
					<Root /></>
				</Provider>
			</BrowserRouter>
		</>
	);
}

export default App;
